/**
 * Public constants.
 */

// Form controller
export const FORM_CONTROLLER_ID = 'Form';
export const FORM_FORMSET_FORM_ADDED_EVENT = 'formsetAdded';
export const FORM_FORMSET_FORM_REMOVED_EVENT = 'formsetRemoved';
export const FORM_BEFORE_SEND_EVENT = 'beforeSend';
export const FORM_SEND_EVENT = 'send';
export const FORM_RESPONSE_HTTP_ERROR_EVENT = 'formResponseHttpError';
export const FORM_RESPONSE_EVENT = 'formResponse';
export const FORM_ERROR_SUMMARY_EVENT = 'errorSummary';
export const FORM_ENABLE_FIELDS_EVENT = 'enableFields';
export const FORM_POST_EVENT_TYPE = 'POST_FORM';

// Lightbox controller
export const LIGHTBOX_CONTROLLER_ID = 'Lightbox';
export const LIGHTBOX_AJAX_ERROR_EVENT = 'ajaxError';
export const LIGHTBOX_CLOSE_EVENT = 'lightbox:close';
export const LIGHTBOX_BACK_EVENT = 'lightbox:back';
export const LIGHTBOX_OPEN_EVENT = 'open';
export const LIGHTBOX_SHOW_ITEM_EVENT = 'showItem';

// Tabs controller
export const TABS_CONTROLLER_ID = 'Tabs';

// Date picker controller
export const DATEPICKER_CONTROLLER_ID = 'Datepicker';

// Toggle controller
export const TOGGLE_CONTROLLER_ID = 'Toggle';
export const TOGGLE_EVENT = 'toggle';
// TODO: Remove in a breaking version
export const TOGGLE_EVENT_NAME = TOGGLE_EVENT;

// PageUpdater controller
export const PAGE_UPDATE_EVENT = 'pageUpdate';
